import ContactCardLexique from 'locales/types/containers/propositionPage/contactCard';

export const contactCardLexique: ContactCardLexique = {
    title: `Votre contact`,
    subText: `En cas de questions, n'hésitez pas à contacter votre conseiller :`,
};

export default contactCardLexique;
